import {ReportItemTemplateField} from '@domain/report-data-set/report-item-template-field.enum';

export class ReportItem {
  private _field: ReportItemTemplateField;
  private _value: any;
  private _title: string;

  public constructor(field: ReportItemTemplateField, value: any, title: string = '') {
    this._field = field;
    this._value = value;
    this._title = title;
  }

  public static fromJSON(reportItemJson: any): ReportItem {
    return new ReportItem(ReportItemTemplateField[reportItemJson.field as string], reportItemJson.value);
  }

  public get field(): ReportItemTemplateField {
    return this._field;
  }

  public set field(field: ReportItemTemplateField) {
    this._field = field;
  }

  public get value(): any {
    return this._value;
  }

  public set value(value: any) {
    this._value = value;
  }

  public get title(): string {
    return this._title;
  }

  public set title(title: string) {
    this._title = title;
  }

  public valueIsObject(): boolean {
    return typeof this.value === 'object' && this.value !== null;
  }

  public valueAsReportItems(): ReportItem[] {
    return this.valueIsObject() ? this.spreadObjectValue() : this.checkAllowedToShowEmpty();
  }

  private spreadObjectValue(): ReportItem[] {
    return Object.entries(this.value).map(([key, value]: [string, unknown]) => new ReportItem(this.field, value, key));
  }

  private checkAllowedToShowEmpty(): ReportItem[] {
    return this._field !== ReportItemTemplateField.STOP_GROUPS ? [this] : [];
  }
}
